/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Loading_Translations_Please_WaitInputs */

const en_loading_translations_please_wait = /** @type {(inputs: Loading_Translations_Please_WaitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Loading ${i?.count} translations... please wait...`)
};

const fr_loading_translations_please_wait = /** @type {(inputs: Loading_Translations_Please_WaitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Chargement de ${i?.count} traductions... veuillez patienter...`)
};

const de_loading_translations_please_wait = /** @type {(inputs: Loading_Translations_Please_WaitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Übersetzungen werden geladen... Bitte warten...`)
};

const it_loading_translations_please_wait = /** @type {(inputs: Loading_Translations_Please_WaitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Caricamento di ${i?.count} traduzioni... attendere prego...`)
};

const ru_loading_translations_please_wait = /** @type {(inputs: Loading_Translations_Please_WaitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Загрузка ${i?.count} переводов... пожалуйста, подождите...`)
};

const es_loading_translations_please_wait = /** @type {(inputs: Loading_Translations_Please_WaitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cargando ${i?.count} traducciones... por favor espere...`)
};

const zh_cn2_loading_translations_please_wait = /** @type {(inputs: Loading_Translations_Please_WaitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`正在加载 ${i?.count} 个翻译……请稍候……`)
};

const ja_loading_translations_please_wait = /** @type {(inputs: Loading_Translations_Please_WaitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}件の翻訳を読み込んでいます...お待ちください...`)
};

const hi_loading_translations_please_wait = /** @type {(inputs: Loading_Translations_Please_WaitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} अनुवाद लोड हो रहे हैं... कृपया प्रतीक्षा करें...`)
};

const pt_pt2_loading_translations_please_wait = /** @type {(inputs: Loading_Translations_Please_WaitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A carregar ${i?.count} traduções... aguarde...`)
};

/**
* | output |
* | --- |
* | "Loading {count} translations... please wait..." |
*
* @param {Loading_Translations_Please_WaitInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const loading_translations_please_wait = /** @type {((inputs: Loading_Translations_Please_WaitInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loading_Translations_Please_WaitInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_loading_translations_please_wait(inputs)
	if (locale === "de") return de_loading_translations_please_wait(inputs)
	if (locale === "it") return it_loading_translations_please_wait(inputs)
	if (locale === "ru") return ru_loading_translations_please_wait(inputs)
	if (locale === "es") return es_loading_translations_please_wait(inputs)
	if (locale === "zh-CN") return zh_cn2_loading_translations_please_wait(inputs)
	if (locale === "ja") return ja_loading_translations_please_wait(inputs)
	if (locale === "hi") return hi_loading_translations_please_wait(inputs)
	if (locale === "pt-PT") return pt_pt2_loading_translations_please_wait(inputs)
	return en_loading_translations_please_wait(inputs)
});